// extracted by mini-css-extract-plugin
export var form = "_dq-0";